import { ITestimonyData } from "../../../types/types";






const testimonyData = (): ITestimonyData => {


  const testimonyData = [
    {
      id: 0,
      imgSrc: "https://res.cloudinary.com/bacf/image/upload/w_400,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_white,b_rgb:ffffff/v1727258316/Era-tek/beneficiary2_rd0ecx.png",
      testimony:
        "The only regret I have is that I didn't get to know them before. The service is top-notch.",
      name: "Ojekunle Azeez",
      role: "Pharmacist",
    },
    {
      id: 1,
      imgSrc: "https://res.cloudinary.com/bacf/image/upload/w_400,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_white,b_rgb:ffffff/v1727258316/Era-tek/beneficiary1_shfxk2.png",
      testimony:
        "Thank you Eratek for opening the “Blessing Signature Page.” It was an easy process. Your team did a great job.",
      name: "Mercy Tofunmi",
      role: "Trader",
    },
    {
      id: 2,
      imgSrc: "https://res.cloudinary.com/bacf/image/upload/w_400,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_white,b_rgb:ffffff/v1727258316/Era-tek/beneficiary3_hspuov.jpg",
      testimony:
        "Thank you for this great opportunity. It's Highly impactful and helpful.",
      name: "Dare Kolawole",
      role: "Makeup Artist",
    },
  ];

  return testimonyData;
};


export default testimonyData;
